import { Outlet } from "react-router-dom";
import classes from "./AiCharactersLayout.module.css";
import { useState } from "react";
import Sidebar from "Layout/Sidebar/Sidebar";
import clsx from "clsx";
import Navbar from "./Navbar/Navbar";
import { useAppContext } from "ContextProvider/ContextProvider";

const AiCharactersLayout = () => {
  const { leftSidebar, setLeftSidebar } = useAppContext();
  return (
    <main
      className={clsx(
        classes.wrapper,
        "wrapper3",
        !leftSidebar && classes.noLeftSidebarWrapper
      )}
    >
      <Navbar sidebar={leftSidebar} setSidebar={setLeftSidebar} />

      <div className={clsx(classes.container, "container2")}>
        <Outlet />
      </div>
    </main>
  );
};
export default AiCharactersLayout;
